import React from 'react';
import SearchInputContainer from '../containers/SearchInputContainer';
import SearchDetailsContainer from '../containers/SearchDetailsContainer';
import Text from '../containers/Text.js';
import {showSearchDetails, hideSearchDetails} from '../actions';
import {connect} from 'react-redux';
import config from '../config/';


const Search = ({showSearchDetails, toggleDetails, filter, country}) => {

  const disableSearchDetails = !!config.countryOptions[country].disableSearchDetails;
  const contentId = 'search-details-container';

  return (
    <div className="search-bar">
      <div className="container-fluid py-md">
        <div className="row">
          <div className="col-12">
            <SearchInputContainer />
          </div>

          {!disableSearchDetails ? (
            <div className="col-12 text-xs-right">
              <button className="btn btn-link pl-0 detail-toggle"
                aria-expanded={showSearchDetails}
                aria-controls={contentId}
                onClick={() => toggleDetails(showSearchDetails)}
              >
                <Text id="search.toggle-details"/>{' '}
                <span
                  className={`halflings halflings-chevron-${showSearchDetails ? 'up' : 'down'}`}
                  aria-hidden="true"
                />
              </button>
            </div>
          ) : null }
        </div>

        <div id={contentId}>
          {showSearchDetails ? <SearchDetailsContainer /> : null }
        </div>
      </div>
    </div>
  )
};

const mapDispatchToProps = (dispatch) => ({
  toggleDetails: isVisible => isVisible
    ? dispatch(hideSearchDetails())
    : dispatch(showSearchDetails())
});

const mapStateToProps = ({search, config}) => ({
  showSearchDetails: search.showSearchDetails,
  filter: search.filter,
  country: config.country
});


export default connect(mapStateToProps, mapDispatchToProps)(Search);
